import React, { useEffect, useState } from "react";
import { Col, Button, Form, Row } from "react-bootstrap";
import { DatePicker } from "antd";
import { Formik } from "formik";
import moment from "moment";
import SingleSelect from "../../../utilities/singleSelect/singleSelect";
import { GetVendor } from "../../../entities/action/action";
const { RangePicker } = DatePicker;

function disabledDate(current) {
  // Can not select days before today and today
  return current && current < moment().endOf("day");
}

const MealPrice = (props) => {
  const [date, updateDate] = useState([]);
  const [mealType, SetMealType] = useState({});
  const [mealTypes, updateMealTypes] = useState([]);
  const [mt, SetMt] = useState([]);
  const [unitPrice, setUnitPrice] = useState("");
  const [cxUnitPrice, setCxUnitPrice] = useState("");
  const [ztUnitPrice, setZtUnitPrice] = useState("");
  const [unitGstRate, setUnitGstRate] = useState([]);
  const [noOfChildren, SetNumberOfChildren] = useState("");
  const [noOfAdults, SetNUmberOfAdults] = useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [select, updateSelect] = useState([]);
  const [select1, updateSelect1] = useState([]);
  const [file1, updateFile1] = useState({});
  const [file2, updateFile2] = useState({});
  const [file3, updateFile3] = useState({});
  const [dataSet, updateDataSet] = useState([]);
  const [amenities, updateAmenities] = useState([]);
  const [vendorList, updateVendorList] = useState([]);
  const [accList, updateAccList] = useState([]);
  const [id, updateId] = useState([]);

  useEffect(() => {
    (async () => {
      const res = await GetVendor();
      if (res != undefined && res.length > 0) {
        const arr = res.filter(
          (item, key) =>
            item.companyInformation.vendortype === "Accommodation Provider"
        );
        console.log(res);
        updateVendorList(arr);
      }
    })();
  }, []);
  const [accomodationId, updateaccomodationId] = useState("");

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem('token');
      const authHeader = `Bearer ${token}`
      const myresponse = await fetch(
        `https://api.zupptravel.com/api/v1/accommodation/getAccommodation`,
        {
          method: "get",
          headers: {
            "Content-Type": "application/json",
            'Authorization': authHeader
          },
        }
      );
      const json = await myresponse.json();

      if (json.success) {
        updateDataSet(json.accommodations);
      }
    })();
  }, []);
  const [vendorId, updateVendorId] = useState("");

  const arr = [];
  useEffect(() => {
    dataSet.map((data, key) => {
      if (data.vendorId == vendorId) {
        arr.push(data);
      }
    });

    updateAccList(arr);
  }, [vendorId]);

  const id1 = [];
  useEffect(() => {
    dataSet.map((data, key) => {
      if (data.accId == accomodationId) {
        id1.push(data.id);
      }
    });
    updateId(id1);
  }, [accomodationId]);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem('token');
      const authHeader = `Bearer ${token}`
      const res = await fetch("https://api.zupptravel.com/api/v1/hotel/getMealType", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          'Authorization': authHeader
        },
      });
      const json = await res.json();

      let arr = [];
      if (json.success) {
        json.mealTypes.map((data, key) => {
          arr.push(data.mealTypes);
        });
        SetMt([...arr]);
        updateMealTypes(json.mealTypes);
      }
    })();
  }, [accomodationId]);

  // console.log(mt);

  // console.log(props.accid);

  // console.log(accomodationId);

  const handlePrice = (x, y, z, a) => {
    setUnitGstRate(x);
    setUnitPrice(y);
    setCxUnitPrice(z);
    setZtUnitPrice(a);
  };

  // console.log("iiiiiiiiiiiiiiiiiii", unitPrice, unitGstRate);

  useEffect(() => {
    let adult, child;
    mealTypes.map((data, key) => {
      if (data.id == mealType.id) {
        SetNUmberOfAdults(data.numberOfAdults);
        SetNumberOfChildren(data.numberOfChildren);
      }
    });
  }, [mealType]);

  // console.log(noOfAdults);

  // console.log(date[1]?._d.toISOString().slice(0, 10));

  // console.log(unitGstRate);
  // console.log(props.id);

  return (
    <div >
      <Formik
        initialValues={
          {
            // unitSericeVariablemsp: "",
            // taxSlabVariablemsp: "",
            // unitSericeVariableocc: "",
          }
        }
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          setSubmitting(true);
          console.log(values);

          const newdata = {
            accommodationId: accomodationId,
            vendorId: vendorId,
            endDate: date[1]?._d.toISOString().slice(0, 10),
            mealAmount: unitPrice,
            mealCXAmount: cxUnitPrice,
            mealCXGstCost: Math.round(cxUnitPrice * 0.01 * unitGstRate),
            mealCXGstRate: unitGstRate,
            mealGstCost: Math.round(unitPrice * 0.01 * unitGstRate),
            mealGstRate: unitGstRate,
            mealPriceId: 0,
            mealTypeId: mealType.id,
            mealZTAmount: ztUnitPrice,
            mealZTGstCost: Math.round(ztUnitPrice * 0.01 * unitGstRate),
            mealZTGstRate: unitGstRate,
            mrp: Math.round(unitPrice + unitPrice * 0.01 * unitGstRate),
            noOfAdults: noOfAdults,
            noOfChildren: noOfChildren,
            purchasePrice: Math.round(
              ztUnitPrice * 0.01 * unitGstRate + ztUnitPrice
            ),
            sellingPrice: Math.round(
              cxUnitPrice + cxUnitPrice * 0.01 * unitGstRate
            ),
            startDate: date[0]?._d.toISOString().slice(0, 10),
          };

          const res = await fetch("https://api.zupptravel.com/api/v1/mealPrice/addMealPrice", {
            method: "post",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newdata),
          });

          console.log("rrrrrrrrrrrr", newdata);
          const json = await res.json();
          console.log("jsonnnnnnnnnn", json);
          if (json.success) {
            alert("Added Meal Price!");
            // // props.click();
            window.location.reload();
          } else {
            alert("Error! Please try again later");
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => (
          <Form onSubmit={handleSubmit}>
            {/* <Form.Group controlId="formBasicAccommodationName" as={Row}>
                                            <Form.Label column sm="2">Accommodation Name:</Form.Label>
                                            <Col sm="10"> 
                                                <Form.Control 
                                                    as="select" 
                                                    placeholder="Accommodation Name" 
                                                    name="accommodationName"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.accommodationName}
                                                    required>
                                                    {
                                                        categoryList.map((categories,key)=>
                                                        <option key={key} value={categories.type}>{categories.type}</option>    
                                                        )
                                                    }
                                                </Form.Control>
                                            </Col>
                                        </Form.Group>    */}
            <Form.Group controlId="formBasicVendor" as={Row}>
              <Form.Label column sm="2">
                Vendor ID:
              </Form.Label>
              <Col sm="10">
                <SingleSelect
                  type="3"
                  list={vendorList}
                  change={(select) => updateVendorId(select)}
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicVendor" as={Row}>
              <Form.Label column sm="2">
                Accommodation ID:
              </Form.Label>
              <Col sm="10">
                <SingleSelect
                  type="4"
                  list={accList}
                  change={(select) => updateaccomodationId(select)}
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicMealType" as={Row}>
              <Form.Label column sm="2">
                Meal Type:
              </Form.Label>
              <Col sm="10">
                <SingleSelect
                  type="6"
                  list={mealTypes}
                  change={(select) => SetMealType(select)}
                />
              </Col>
              {/* <Col sm="10"> 
                                                <Form.Control 
                                                    as="select" 
                                                    placeholder="Meal Type" 
                                                    name="mealType"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.mealType}
                                                    required>
                                                        <option value=''>--Select--</option>
                                                    {
                                                        mealTypes.map((categories,key)=>
                                                        <option key={key} value={categories.mealType}>{categories.mealType}</option>    
                                                        )
                                                    }
                                                </Form.Control>
                                            </Col> */}
            </Form.Group>
            <Form.Group controlId="formBasictimePerSlot" as={Row}>
              <Form.Label column sm="2">
                Date:
              </Form.Label>
              <Col>
                <RangePicker
                  onChange={(val) => updateDate(val)}
                  value={date}
                  disabledDate={disabledDate}
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicMetaNoOfAdults" as={Row}>
              <Form.Label column sm="2">
                No. of Adults:
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  readOnly
                  type="text"
                  placeholder="Enter No. of Adults"
                  name="noOfAdults"
                  value={noOfAdults}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Group controlId="formBasicMetaNoOfChildren" as={Row}>
              <Form.Label column sm="2">
                No. of children/infant:
              </Form.Label>
              <Col sm="10">
                <Form.Control
                  readOnly
                  type="text"
                  placeholder="Enter No. of children/infant"
                  name="noOfChildren"
                  value={noOfChildren}
                  required
                />
              </Col>
            </Form.Group>
            <Form.Label style={{ fontWeight: "bold" }}>Meal Cost:</Form.Label>
            <div style={{ border: "1px solid grey" }} className="container">
              <Form.Group
                controlId="formBasicMrp"
                as={Row}
                style={{ margin: "1% 0" }}
              >
                <Form.Label>Unit Price:</Form.Label>
                <Col>
                  <Form.Control
                    type="number"
                    step={0.01}
                    placeholder="Enter Unit Price"
                    name="unitSericeVariablemsp"
                    min={0}
                    onChange={handleChange}
                    value={values.unitSericeVariablemsp}
                    required
                  />
                </Col>
                <Form.Label>Unit GST Rate:</Form.Label>
                <Col>
                  <Form.Control
                    type="number"
                    step={0.01}
                    placeholder="G.S.T Rate"
                    name="taxSlabVariablemsp"
                    min={1}
                    max={100}
                    isInvalid={
                      values.taxSlabVariablemsp < 0 ||
                      values.taxSlabVariablemsp > 100
                    }
                    onChange={handleChange}
                    value={values.taxSlabVariablemsp}
                    required
                  />
                </Col>
                <Form.Label>GST Cost:</Form.Label>
                <Col>
                  <Form.Control
                    readOnly
                    name="taxRateVariablemsp"
                    onChange={handleChange}
                    value={Math.round(
                      values.unitSericeVariablemsp *
                        0.01 *
                        values.taxSlabVariablemsp
                    )}
                    required
                  />
                </Col>
                <Form.Label>M.R.P:</Form.Label>
                <Col>
                  <Form.Control
                    type="number"
                    step={0.01}
                    readOnly
                    min={0}
                    placeholder="M.R.P"
                    name="variableCostmsp"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={Math.round(
                      values.unitSericeVariablemsp +
                        values.unitSericeVariablemsp *
                          0.01 *
                          values.taxSlabVariablemsp
                    )}
                    required
                  />
                </Col>
              </Form.Group>
              <Form.Group
                controlId="formBasicAppliesTo"
                as={Row}
                style={{ margin: "1% 0" }}
              ></Form.Group>
            </div>
            <Form.Label style={{ fontWeight: "bold" }}>
              Meal Cost to CX:
            </Form.Label>
            <div style={{ border: "1px solid grey" }} className="container">
              <Form.Group
                controlId="formBasicMrp"
                as={Row}
                style={{ margin: "1% 0" }}
              >
                <Form.Label>Unit Price:</Form.Label>
                <Col>
                  <Form.Control
                    type="number"
                    step="any"
                    placeholder="Enter Unit Price"
                    name="unitSericeVariableocc"
                    min={0}
                    isInvalid={
                      values.unitSericeVariableocc >
                      values.unitSericeVariablemsp
                    }
                    onChange={handleChange}
                    value={values.unitSericeVariableocc}
                    required
                  />
                </Col>
                <Form.Label>Unit GST Rate:</Form.Label>
                <Col>
                  <Form.Control
                    type="number"
                    step="any"
                    placeholder="G.S.T Rate"
                    name="taxSlabVariableocc"
                    min={1}
                    readOnly
                    max={100}
                    isInvalid={
                      values.taxSlabVariablemsp < 0 ||
                      values.taxSlabVariablemsp > 100
                    }
                    onChange={handleChange}
                    value={values.taxSlabVariablemsp}
                    required
                  />
                </Col>
                <Form.Label>GST Cost:</Form.Label>
                <Col>
                  <Form.Control
                    readOnly
                    defaultValue="0"
                    name="taxRateVariableocc"
                    onChange={handleChange}
                    value={Math.round(
                      values.unitSericeVariableocc *
                        0.01 *
                        values.taxSlabVariablemsp
                    )}
                    required
                  />
                </Col>
                <Form.Label>Selling Price:</Form.Label>
                <Col>
                  <Form.Control
                    type="number"
                    step="any"
                    readOnly
                    min={0}
                    placeholder="Selling Price"
                    name="variableCostocc"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={Math.round(
                      values.unitSericeVariableocc +
                        values.unitSericeVariableocc *
                          0.01 *
                          values.taxSlabVariablemsp
                    )}
                    required
                  />
                </Col>
              </Form.Group>
              <Form.Group
                controlId="formBasicAppliesTo"
                as={Row}
                style={{ margin: "1% 0" }}
              ></Form.Group>
            </div>
            <Form.Label style={{ fontWeight: "bold" }}>
              Meal Cost to ZT:
            </Form.Label>
            <div style={{ border: "1px solid grey" }} className="container">
              <Form.Group
                controlId="formBasicMrp"
                as={Row}
                style={{ margin: "1% 0" }}
              >
                <Form.Label>Unit Price</Form.Label>
                <Col>
                  <Form.Control
                    type="number"
                    step="any"
                    placeholder="Enter Unit Price"
                    name="unitSericeVariableww"
                    min={0}
                    readOnly
                    value={Math.round(values.unitSericeVariableocc * 0.8675)}
                    required
                  />
                </Col>
                <Form.Label>Unit GST Rate:</Form.Label>
                <Col>
                  <Form.Control
                    type="number"
                    step="any"
                    placeholder="G.S.T Rate"
                    name="taxSlabVariableww"
                    min={1}
                    max={100}
                    readOnly
                    isInvalid={
                      values.taxSlabVariablemsp < 0 ||
                      values.taxSlabVariablemsp > 100
                    }
                    value={Math.round(values.taxSlabVariablemsp)}
                    required
                  />
                </Col>
                <Form.Label>GST Cost:</Form.Label>
                <Col>
                  <Form.Control
                    readOnly
                    defaultValue="0"
                    name="taxRateVariableww"
                    value={Math.round(
                      values.unitSericeVariableocc *
                        0.8675 *
                        0.01 *
                        values.taxSlabVariablemsp
                    )}
                    required
                  />
                </Col>
                <Form.Label>Purchase Price:</Form.Label>
                <Col>
                  <Form.Control
                    type="number"
                    step="any"
                    readOnly
                    min={0}
                    placeholder="Purchase Price"
                    name="variableCostww"
                    value={Math.round(
                      values.unitSericeVariableocc *
                        0.8675 *
                        0.01 *
                        values.taxSlabVariablemsp +
                        values.unitSericeVariableocc * 0.8675
                    )}
                    required
                  />
                </Col>
              </Form.Group>
            </div>
            <center>
              <Button
                style={{ marginTop: "15px" }}
                type="submit"
                variant="success"
              >
                Save Meal Price
              </Button>
            </center>

            {handlePrice(
              values.taxSlabVariablemsp,
              values.unitSericeVariablemsp,
              values.unitSericeVariableocc,
              values.unitSericeVariableocc * 0.8675
            )}
          </Form>
        )}
      </Formik>
    </div>
  );
};
export default MealPrice;
